import { z } from 'zod';
import { nullableDefaultObject } from '..';
import { roleSchema, userSchema } from '../types/users';

const partialUserSchema = nullableDefaultObject(userSchema);

export const userFormSchema = partialUserSchema.pick({
    global_name: true,
    description: true,
    country: true,
});

export type userFormInput = z.input<typeof userFormSchema>;
export type userFormOutput = z.output<typeof userFormSchema>;

export const fullEditUserFormSchema = partialUserSchema
    .pick({
        global_name: true,
        description: true,
        country: true,
        ban_level: true,
    })
    .extend({
        roles: z.array(roleSchema),
    });

export type fullEditUserFormInput = z.input<typeof fullEditUserFormSchema>;
export type fullEditUserFormOutput = z.output<typeof fullEditUserFormSchema>;
